/*
 * File: IntervalInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/7/2023
 * Copyright (c) DrivingDoc 2023
 */
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes {
  name: string;
  label?: string;
  helperText?: string;
  years?: boolean;
  months?: boolean;
  weeks?: boolean;
  days?: boolean;
  hours?: boolean;
  minutes?: boolean;
  seconds?: boolean;
}

export default function IntervalInput({ name, label, helperText, ...fieldVisible }: PropTypes) {
  const { control } = useFormContext();
  return (
    <Stack>
      <Typography variant="subtitle2">{label}</Typography>

      <Stack direction="row">
        {fieldVisible.years && (
          <Controller
            control={control}
            name={`${name}.years`}
            render={({ field, fieldState }) => (
              <TextField
                label="Years"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}
        {fieldVisible.months && (
          <Controller
            control={control}
            name={`${name}.months`}
            render={({ field, fieldState }) => (
              <TextField
                label="Months"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}

        {fieldVisible.weeks && (
          <Controller
            control={control}
            name={`${name}.weeks`}
            render={({ field, fieldState }) => (
              <TextField
                label="Weeks"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}

        {fieldVisible.days && (
          <Controller
            control={control}
            name={`${name}.days`}
            render={({ field, fieldState }) => (
              <TextField
                label="Days"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}

        {fieldVisible.hours && (
          <Controller
            control={control}
            name={`${name}.hours`}
            render={({ field, fieldState }) => (
              <TextField
                label="Hours"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}

        {fieldVisible.minutes && (
          <Controller
            control={control}
            name={`${name}.minutes`}
            render={({ field, fieldState }) => (
              <TextField
                label="Minutes"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}

        {fieldVisible.seconds && (
          <Controller
            control={control}
            name={`${name}.seconds`}
            render={({ field, fieldState }) => (
              <TextField
                label="Seconds"
                type="number"
                variant="standard"
                fullWidth
                slotProps={{
                  htmlInput: { min: 0 },
                  inputLabel: { shrink: true },
                }}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                ref={field.ref}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.value);
                }}
              />
            )}
          />
        )}
      </Stack>
      {helperText && <FormHelperText variant="standard">{helperText}</FormHelperText>}
    </Stack>
  );
}
